var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full flex flex-col"},[_c('Header1',{attrs:{"label":"Bestellungen"}}),_c('OrderList',{attrs:{"isInvoice":true,"data":_vm.orders}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }